import { render, staticRenderFns } from "./ProductVariantList.vue?vue&type=template&id=6b107d28&lang=pug&"
import script from "./ProductVariantList.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProductVariantList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ProductVariantList.vue?vue&type=style&index=0&id=6b107d28&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports